import React from 'react';
import { InView } from 'react-intersection-observer';
import '../styles/heroa.css';

const AboutHero = () => {
    return (
        <section
            className="about-hero-section"
            role="banner"
            aria-labelledby="heroa-title"
        >
            {/* Animated background circles - fallback if SVG doesn't load */}
            <div className="background-circles">
                <div className="circle circle-1"></div>
                <div className="circle circle-2"></div>
                <div className="circle circle-3"></div>
                <div className="circle circle-4"></div>
                <div className="circle circle-5"></div>
            </div>

            {/* Content container - properly centered */}
            <div className="content-container">
                <InView triggerOnce={true} threshold={0.1}>
                    {({ inView, ref }) => (
                        <header
                            ref={ref}
                            className={`content-header ${
                                inView
                                    ? 'animate-in'
                                    : 'animate-out'
                            }`}
                        >
                            <h1
                                id="heroa-title"
                                className="heroa-title"
                            >
                                Empowering Businesses Since 2006<br/>
                            </h1>
                        </header>
                    )}
                </InView>
            </div>

            {/* Overlay for better text readability */}
            <div className="overlay"></div>
        </section>
    );
};

export default AboutHero;